<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-28 11:09:14
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-09 15:57:02
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/components/ExhibitsInfoItem.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div @click="handleJumpPage(item)" class=" bg-white d-flex border-box p-10 mt-10" style="border-radius: 10px;min-height: 89px;width:100%;">
    <img class="flex-shrink-0 mr-10" :src="item.cover" alt="" style="width: 107px;height:86px;border-radius: 12px;">
    <div class="flex-1">
      <div class="fw-5 cor-262626 fz-13 text-overflow-ellipsis-1" style="width: 194px;">{{ item.exhibitName }}</div>
      <div class="cor-8C8C8C mt-5 fz-11" v-if="getType.name">{{ getType.name  }}</div>
      <div class="d-flex flex-wrap " style="margin-top: 8px;">
        <div v-for="(v,i) in getItem" :key="i" class="cor-9E9E9E d-flex flex-center  fz-11 mr-5 mb-5" style="padding: 2px 4px;height: 17px;border-radius: 3px;border: 1px solid #E0E0E0;">{{ v.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExhibitsInfoItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {},
  computed: {
    getType() {
      let type = 'TYPE'
      let obj = this.item.productAttributeVos ? this.item.productAttributeVos.find((res) => res.type == type) : []
      return obj ? (Object.keys(obj).length == 0 ? { name: '' } : obj) : []
    },
    getItem() {
      let type = 'TYPE'
      let arr = this.item.productAttributeVos ? this.item.productAttributeVos : []
      return arr ? arr.filter((res) => res.type != type) : []
    },
  },
  data() {
    return {}
  },
  methods: {
    handleJumpPage(item) {
      this.$router.push({
        path: '/mini-h5/index/exhibitsDetail',
        query: {
          exhibitCode: item.exhibitCode,
        },
      })
    },
  },
  mounted() {},
}
</script>
<style scoped lang="less"></style>